/* eslint-disable no-useless-escape */
import axios from "axios";
import configs from "@/common/config";
const isProduct = process.env.NODE_ENV === "production";
const ajaxUrl = isProduct ? configs.apiUrl : configs.devApiUrl;
export default {
  uuid: function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
  },
  reLogin() {
    axios.post(`${ajaxUrl}/user/auth/login`, null, {
      headers: {
        "X-UserId": "2815862301",
      },
    }).then(res => {
      if (res.data && res.data.code === 200) {
        location.reload();
      }
    });
  },
  openUrl(url) {
    if (!url) {
      return;
    } else if (!url.includes("http://") && !url.includes("https://")) {
      url = "http://" + url;
    }
    // 处理其他情况，例如本地文件或数据URI
    window.open(url, "__blank");
  },
  // 获取域名链接等信息
  getDomain(url, isHttp) {
    let domain = "null";
    if (typeof url === "undefined" || url === null) {
      url = window.location.href;
    }
    if (!url.includes("http://") && !url.includes("https://")) {
      url = "http://" + url;
    }
    const regex = /(\w+):\/\/([^/:]+)(:\d*)?/;
    const match = url.match(regex);
    if (typeof match !== "undefined" && match !== null) {
      if (!isHttp) {
        domain = match[2];
      }
      if (isHttp) {
        domain = match[0];
      }
    }
    return domain;
  },
  // 获取url参数
  getUrlParams(str) {
    if (!str) {
      return "";
    }
    let search = str.includes("?") ? str.split("?")[1] : str;
    // 忽略#后面的哈希片段
    let cleanStr = search.includes("#") ? search.split("#")[0] : search;
    let params = cleanStr.split("&");
    let query = {};
    params.forEach((item) => {
      let key = item.split("=");
      query[key[0]] = key[1];
    });
    return query;
  },
  // 图片地址转blob流
  urlToBlob(url, callBack) {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = url;
    return new Promise((resolve) => {
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        // 转换
        const imgBase64 = canvas.toDataURL();
        callBack(imgBase64);
        resolve(imgBase64);
      };
      image.onerror = function () {
        callBack(false);
        resolve(false);
      };
    });
  },
  // 加载图片返回blob流
  getFileBlob(imgUrl) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      // http 图片加载限制
      if (!imgUrl.includes("https")) {
        imgUrl.replace("http", "https");
      }
      imgUrl = imgUrl.trim() + `?r=${Math.random()}`;
      xhr.open("GET", imgUrl, true);
      xhr.responseType = "blob";
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          resolve(); // 避免图片下载失败，导致批量导出失败
        }
      };
      xhr.onerror = () => {
        reject();
      };
      xhr.send();
    });
  },
  base64ToBlob(dataurl) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  },
  // file | blob转base64
  blobToBase64(blob, callback) {
    return new Promise((resolve) => {
      let a = new FileReader();
      if (blob) {
        a.readAsDataURL(blob);
      }
      a.onload = async function (e) {
        const AsyncFunction = (async () => { }).constructor;
        // 判断callback是否是异步的回调
        if (callback) {
          if (callback instanceof AsyncFunction) {
            await callback(e.target.result);
          } else {
            callback(e.target.result);
          }
        }
        resolve(e.target.result);
      };
    });
  },
  async getImageFileSize(src) {
    try {
      const fullResponse = await fetch(src);
      const length = fullResponse.headers.get("Content-Length");
      return length ? parseInt(length) : null;
    } catch (error) {
      console.error("获取文件大小失败:", error);
      return null;
    }
  },
  // 判断是否是空对象
  isEmptyObj(val) {
    for (let k in val) {
      return false;
    }
    return true;
  },
  // 对比俩个数组的值
  contrastArray(Array1, Array2) {
    let result = true;
    if (Array1.length !== Array2.length) {
      return false;
    }
    for (let key in Array1) {
      let array2Val = Array2.find(
        (val) => val.parentSpecId === Array1[key].parentSpecId
      );
      if (!array2Val) {
        return false;
      }
      for (let val in Array1[key]) {
        if (Array1[key][val] !== array2Val[val]) {
          return false;
        }
      }
    }
    return result;
  },
  // 数字和字母
  onlyNumAndEcglishCheck(value) {
    var reg = /[^0-9a-zA-Z]/;
    return reg.test(value);
  },
  //英文字母、数字或标点符号
  onlyNumAndEcglishPointCheck(value) {
    var reg = /^[a-z_A-Z0-9-\.!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\·`\?:;|]+$/;
    return reg.test(value);
  },
  // 加减乘除运算 返回结果
  operationVal(symbol, baseVal, addVal) {
    baseVal = Number(baseVal);
    addVal = Number(addVal);
    let result = 0;
    switch (symbol) {
      case "0":
        result = baseVal + addVal;
        break;
      case "1":
        result = baseVal - addVal;
        break;
      case "2":
        result = baseVal * addVal;
        break;
      case "3":
        result = baseVal / addVal;
        break;
      case "4":
        result = addVal;
        break;
      default:
        break;
    }
    return result;
  },
  integrateArray(startArr, targetArr) {
    /**
     * 排列组合二维数组的数据
     * startArr 开始数组  默认【】
     * targetArr 目标数组
     */
    let result = [];
    targetArr.forEach((t) => {
      let arr = [t];
      if (startArr.length) {
        startArr.forEach((s) => {
          let copyArr = s.concat(arr);
          result.push(copyArr);
        });
      } else {
        result.push(arr);
      }
    });
    return result;
  },
  downLoadExcel(jsonData, names, excelName, callback) {
    const platform = window.navigator.platform;
    if (platform && platform == 'MacIntel') {
      const data = {};
      names.forEach((el) => (data[el] = ''));
      jsonData.unshift(data);
      const str = jsonToCSV(jsonData);
      const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
      const name = excelName || '下载表格';
      if (document.querySelector('#gj-export-excel')) {
        document.querySelector('#gj-export-excel').setAttribute('href', uri);
        document.querySelector('#gj-export-excel').setAttribute('download', name + '.csv');
        document.querySelector('#gj-export-excel').click();
      } else {
        const a = document.createElement('a');
        a.id = 'gj-export-excel';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.setAttribute('href', uri);
        a.setAttribute('download', name + '.csv');
        a.click();
      }
      callback && callback();
      return;
    }
    // 输出base64编码
    const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)));
    // 列标题
    let str = ``;
    if (names) {
      str += '<tr>';
      names.forEach((el) => {
        str += `<td>${el}</td>`;
      });
      str += '</tr>';
    }
    // 循环遍历，每行加入tr标签，每个单元格加td标签
    for (let i = 0; i < jsonData.length; i++) {
      str += '<tr style="height: 70px; text-align: center;padding:5px;">';
      for (const key in jsonData[i]) {
        // 增加\t为了不让表格显示科学计数法或者其他格式
        if (key === 'image') {
          str += `<td><img src="${jsonData[i][key]}" alt="${jsonData[i][key]}" width="60" height="60"></td>`;
        } else {
          str += `<td>${jsonData[i][key] || '-' + '\t'}</td>`;
        }
      }
      str += '</tr>';
    }
    // Worksheet名
    const worksheet = 'Sheet1';
    const uri = 'data:application/vnd.ms-excel;base64,';
    // 下载的表格模板数据
    const template = `<html xmlns:o='urn:schemas-microsoft-com:office:office'
    xmlns:x='urn:schemas-microsoft-com:office:excel'
    xmlns='http://www.w3.org/TR/REC-html40'>
    <head>
    <meta name='ProgId' content='Excel.Sheet' />
    <meta name='Generator' content='Microsoft Excel 11' />
    <meta http-equiv='Content-Type' content='text/html; charset=UTF-8' />
    <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
    <x:Name>${worksheet}</x:Name>
    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
    </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
    </head><body><table>${str}</table></body></html>`;

    const excelHref = uri + base64(template);
    const name = excelName || '下载表格';
    if (document.querySelector('#gj-export-excel')) {
      document.querySelector('#gj-export-excel').setAttribute('href', excelHref);
      document.querySelector('#gj-export-excel').setAttribute('download', name + '.xls');
      document.querySelector('#gj-export-excel').click();
    } else {
      const a = document.createElement('a');
      a.id = 'gj-export-excel';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.setAttribute('href', excelHref);
      a.setAttribute('download', name + '.xls');
      a.click();
    }
    callback && callback();
  }
};
